const STATUS_COLORS = {
  PAID: "#B6EFBB",
  SUCCESS: "#B6EFBB",
  "DELIVERY SUCCESSFUL": "#B6EFBB",

  FAILED: "#F7ABAB",
  "DELIVERY FAILED": "#F7ABAB",

  ORDER_DETECTED: "#FFE5B7",
  OPENED_DOOR: "#C5F1C5",

  PRE_OPEN: "#D0DCFD",
  PRE_PAYMENT: "#D0DCFD",
  PENDING: "#D0DCFD",
};


export const getOrderStatusColor = (status) => {
  if (!status) return "transparent";

  const normalizedStatus = status?.toUpperCase();

  return STATUS_COLORS[normalizedStatus] || "#fdf8b5ff";
};